import Component_Skybox3D_785ea0697154071c383660557ec3fcae from "../../../../content/examples/gui/skybox-3d/Skybox3D";
import Devtool_Skybox3D_785ea0697154071c383660557ec3fcae from "!!@devtool/loader!../../../../content/examples/gui/skybox-3d/Skybox3D";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Skybox3D_785ea0697154071c383660557ec3fcae,
  Devtool_Skybox3D_785ea0697154071c383660557ec3fcae,
  DevTool,
  React
};